/** Same-origin relative path only (open-redirect defense). The WHATWG parser is the judge rather
 * than string patterns: `//host` and `/\host` (`\` parses as `/`) resolve to another origin, and
 * tab/newline are stripped before parsing so `/\t//host` would too. Pure module (no `.server`
 * suffix) so route-level `validateSearch` can share the exact same rule instead of mirroring it. */
export function sanitizeRedirect(url?: string): string | undefined {
  if (!url || !url.startsWith("/") || /[\t\n\r\\]/.test(url)) return undefined;
  const base = "http://same-origin";
  return new URL(url, base).origin === base ? url : undefined;
}
